import React from "react";
import BackArrow from "@rosette/web_components/src/icon/BackArrow.js";
import { cn } from "@rosette/ts/src/util/cn.js";


interface BackButtonProps {
    className?: string;
    label?: string;
    onClick: () => void;
}

export default function BackButton({ className = "", label, onClick }: BackButtonProps) {
    return (
        <button
            type="button"
            className={cn(
                "flex flex-row items-center text-xl max-md:mt-4 cursor-pointer",
                "hover:text-strong hover:underline",
                className,
            )}
            onClick={onClick}>

            <BackArrow />
            <span>
                {label ?? "Back"}
            </span>
        </button>
    );
}
